/*
  Add here your own custom javascript codes
*/

window.theme = window.theme || {}

window.theme.recentlyViewed = {
  storageKey: 'ksRecentlyViewedProducts',
  maxItems: 20
}

window.theme.readRecentlyViewedProducts = function () {
  try {
    const value = window.localStorage.getItem(window.theme.recentlyViewed.storageKey)
    const products = JSON.parse(value || '[]')
    return Array.isArray(products) ? products : []
  } catch (error) {
    return []
  }
}

window.theme.writeRecentlyViewedProducts = function (products) {
  try {
    window.localStorage.setItem(
      window.theme.recentlyViewed.storageKey,
      JSON.stringify(products.slice(0, window.theme.recentlyViewed.maxItems))
    )
  } catch (error) {}
}

window.theme.storeCurrentProductInRecentlyViewed = function () {
  document.querySelectorAll('[data-recently-viewed-set][data-product-id]').forEach((element) => {
    const product = {
      id: Number(element.dataset.productId),
      url: element.dataset.productUrl,
      title: element.dataset.productTitle,
      price: Number(element.dataset.productPrice || 0),
      compareAtPrice: Number(element.dataset.productCompareAtPrice || 0),
      available: element.dataset.productAvailable === 'true',
      image: element.dataset.productImage || ''
    }

    if (!product.id || !product.url || !product.title) return

    const existingProducts = window.theme.readRecentlyViewedProducts()
    const products = [
      product,
      ...existingProducts.filter((item) => Number(item.id) !== product.id)
    ]

    window.theme.writeRecentlyViewedProducts(products)
  })
}

window.theme.storeCurrentProductInRecentlyViewed()
window.addEventListener('DOMContentLoaded', window.theme.storeCurrentProductInRecentlyViewed)
document.addEventListener('shopify:section:load', window.theme.storeCurrentProductInRecentlyViewed)

class RecentlyViewedProducts extends HTMLElement {
  connectedCallback () {
    this.render()
  }

  readProducts () {
    return window.theme.readRecentlyViewedProducts()
      .filter((product) => Number(product.id) !== Number(this.dataset.currentProductId))
      .slice(0, Number(this.dataset.limit || 8))
  }

  escapeHtml (value = '') {
    return value
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
  }

  renderPrice (product) {
    const price = window.Shopify.formatMoney(product.price)
    const compareAtPrice = Number(product.compareAtPrice || 0)

    if (compareAtPrice > product.price) {
      return `
        <p class="product-card-price product-price mb-0">
          <s class="product-card-price-compare">
            <span class="visually-hidden">${window.theme.locales.product.regular_price}</span>
            ${window.Shopify.formatMoney(compareAtPrice)}
          </s>
          <span class="product-card-price-final product-price-final-sale">
            <span class="visually-hidden">${window.theme.locales.product.sale_price}</span>
            ${price}
          </span>
        </p>
      `
    }

    return `
      <p class="product-card-price product-price mb-0">
        <span class="product-card-price-final">
          ${price}
        </span>
      </p>
    `
  }

  renderCard (product) {
    const imageClass = this.dataset.cardImageBorder || ''
    const textAlign = this.dataset.cardTextAlign || ''
    const titleClass = this.dataset.cardTitleClass || 'h6'
    const soldOutText = window.theme.locales.product.sold_out
    const soldOutBadge = product.available
      ? ''
      : `<span class="product-sold-out-badge badge">${soldOutText}</span>`
    const image = product.image
      ? `<img src="${this.escapeHtml(product.image)}" class="product-card-img" loading="lazy" alt="${this.escapeHtml(product.title)}">`
      : '<div class="recently-viewed-placeholder"></div>'

    return `
      <div class="swiper-slide p-4 p-desktop-5">
        <div class="product-card ${textAlign}">
          <a href="${this.escapeHtml(product.url)}" class="product-card-link">
            <div class="product-card-img-wrapper mb-4 product-card-img-square ${imageClass}">
              ${soldOutBadge}
              ${image}
            </div>
            <h3 class="product-card-title product-title ${titleClass}">
              ${this.escapeHtml(product.title)}
            </h3>
            ${this.renderPrice(product)}
          </a>
        </div>
      </div>
    `
  }

  initSlider () {
    const sliderElement = this.querySelector('.swiper')
    if (!sliderElement || !window.Swiper) return

    this.slider?.destroy(true, true)

    this.slider = new window.Swiper(sliderElement, {
      speed: Number(this.dataset.sliderSpeed || 300),
      autoplay: this.dataset.sliderAutoplay === '0'
        ? undefined
        : { delay: Number(this.dataset.sliderAutoplay) * 1000 },
      navigation: {
        enabled: this.dataset.sliderNavigation === 'true',
        prevEl: this.querySelector('.swiper-button-prev'),
        nextEl: this.querySelector('.swiper-button-next')
      },
      pagination: {
        enabled: this.dataset.sliderPagination === 'true',
        el: this.querySelector('.swiper-pagination'),
        type: 'bullets',
        dynamicBullets: true,
        dynamicMainBullets: 2
      },
      scrollbar: {
        enabled: this.dataset.sliderScrollbar === 'true',
        el: this.querySelector('.swiper-scrollbar'),
        draggable: true
      },
      breakpoints: {
        0: { slidesPerView: Number(this.dataset.breakpointMobile || 1) },
        600: { slidesPerView: Number(this.dataset.breakpointTablet || 2) },
        1200: { slidesPerView: Number(this.dataset.breakpointDesktop || 4) }
      },
      rewind: true
    })
  }

  render () {
    const products = this.readProducts()
    const wrapper = this.querySelector('[data-recently-viewed-slides]')
    const slider = this.querySelector('[data-recently-viewed-slider]')
    const emptyState = this.querySelector('[data-recently-viewed-empty]')
    const isDesignMode = Boolean(window.Shopify && window.Shopify.designMode)

    if (!wrapper || !slider || !emptyState) return

    if (products.length === 0) {
      wrapper.innerHTML = ''

      if (isDesignMode) {
        emptyState.removeAttribute('hidden')
        slider.setAttribute('hidden', 'hidden')
        this.removeAttribute('hidden')
      } else {
        this.setAttribute('hidden', 'hidden')
        this.closest('.shopify-section')?.setAttribute('hidden', 'hidden')
      }

      return
    }

    wrapper.innerHTML = products.map((product) => this.renderCard(product)).join('')

    this.removeAttribute('hidden')
    this.closest('.shopify-section')?.removeAttribute('hidden')
    emptyState.setAttribute('hidden', 'hidden')
    slider.removeAttribute('hidden')

    this.initSlider()
  }
}

customElements.define('recently-viewed-products', RecentlyViewedProducts)
